import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "system-type-card" }
const _hoisted_2 = { class: "type-buttons" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "intro-card" }
const _hoisted_5 = { class: "product-images" }
const _hoisted_6 = {
  key: 0,
  class: "main-image"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "thumbnail-list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "intro-quote" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "table-card" }
const _hoisted_15 = { class: "toolbar" }
const _hoisted_16 = { class: "checkbox-label" }
const _hoisted_17 = { class: "selected-info" }
const _hoisted_18 = { class: "table-responsive" }
const _hoisted_19 = { class: "checkbox-col" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "table-footer" }
const _hoisted_22 = { class: "total-price" }
const _hoisted_23 = { class: "price-amount" }
const _hoisted_24 = { class: "pay-box" }
const _hoisted_25 = { class: "qrcode-wrap" }
const _hoisted_26 = { class: "price" }

import Foot from '@/components/layout/Foot.vue'
import { ref,nextTick, computed, onMounted, onUnmounted } from 'vue'
import SidebarPC from '@/components/layout/SidebarPC.vue'
import SidebarMobile from '@/components/layout/SidebarMobile.vue'
import MobileHeader from '@/components/layout/MobileHeader.vue'
import { ShopTypeEmun} from '@/httpRequest/ShopEmun';
 import {CreateShopOrder,GetOrdersOnlinePayment} from '@/httpRequest/orderRequest';
  import {AlipayAbnormalForOrderPay} from '@/httpRequest/PayRequest';
import {
  GetListBusinessCategory,categoryData,Productlist
} from "../httpRequest/ProductRequest";import { ElMessageBox, ElMessage } from 'element-plus'; 
   import { useRoute, useRouter } from "vue-router/dist/vue-router";
// 引入二维码插件
import QRCode from 'qrcodejs2'

 
export default /*@__PURE__*/_defineComponent({
  __name: 'ConsoleView',
  setup(__props) {

;
let pollTimer: number | null = null
    const payDialogVisible = ref(false)

        const router = useRouter()
 const closePayDialog = () => {
                            payDialogVisible.value = false
                            //   clearInterval(pollTimer)
                            clearInterval(pollTimer!)
                            pollTimer = null
                            // 清空二维码容器，防止重复叠加
                            const qrDom = document.getElementById('qrcodes')
                            if (qrDom) qrDom.innerHTML = ''
                }
           
// 支付弹窗

const qrcodeCanvas = ref(null)
 const currentImage = ref(0)
 const currentCategory = ref(1);
// 响应式状态
const isMobile = ref(false)
const sidebarOpen = ref(false)
const currentPage = ref('首页')
const selectedType = ref(0)
const selectedItems = ref<string[]>([]);
const userName = ref('admin')
 const products = ref([]);
const originalData = ref<categoryData[]>([]);
// 产品图片数据
const productImages = ref([])
// const productImages = ref([
//   'https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?w=400&h=400&fit=crop',
//   'https://images.unsplash.com/photo-1581092335871-4e7c6582ef94?w=400&h=400&fit=crop',
//   'https://images.unsplash.com/photo-1581092335871-4e7c6582ef95?w=400&h=400&fit=crop',
//   'https://images.unsplash.com/photo-1581092335871-4e7c6582ef96?w=400&h=400&fit=crop'
// ])
// //分类调用接口获取所有数据
const ListBusinessCategory = async (data: any) => {
  var getListBusinessCategory = await GetListBusinessCategory({
    categeroyId: data
  });
  debugger

  originalData.value = getListBusinessCategory.data;
  selectedType.value= getListBusinessCategory.data[0].categeroyId
  console.log("selectedType",selectedType.value);
   DealProductsdata(selectedType.value);
  //getListBusinessCategory.filter(p=>p.parentId==0).tolist();
};


 


// 系统类型
const systemTypes = ['物料标签管理系统', '电商系统', '电商ERP']

// 展平成行数据
const rows = computed(() => {
  const flat = [];
  let mainSn = 1; // 商品主序号

  products.value.forEach((product, index) => {
    const skus = product.productsGetSkuDto?.productsSkuInfoDto || [];
     const hasChildren = skus.length > 0;
    // 商品本身行
    flat.push({
      id: `p-${product.id}`,                // 唯一标识，加前缀避免与 skuId 冲突
      type: 'product',
      productid:product.id,
      skuid:'0',
      sn: mainSn,
      moduleName: product.productName,
      function: '',                          // 商品行功能留空
      proUnitNum:product.proUnitNum,
      proUnit:product.proUnit,
      days: product.proUnitNum+"("+product.proUnitName+")", // 示例：基础资料用180，其他用0
      quantity: product.stockQty || 1,
      price: product.price || 0,
      hasChildren
    });

    // 如果有 SKU，添加子行
   
     let subSn = 1;
    skus.forEach(sku => {
      flat.push({
        id: `s-${sku.skuId}`,
        productid:product.id,
        skuid:sku.skuId,
         proUnitNum:product.proUnitNum,
        proUnit:product.proUnit,
        type: 'sku',
        sn: `${mainSn}.${subSn}`, // 层级序号
        moduleName: product.productName,
        function: sku.productsSpecsValueId?.join(' / ') || '',
        days: product.proUnitNum+"("+product.proUnitName+")",                            // 示例：SKU 天数固定为111
        quantity: sku.stockQty || 1,
        price: sku.price || 0
      });
       subSn++;
    });
     mainSn++; // 处理下一个商品
  });
  return flat;
});

// 所有可选行的 id 列表
const allIds = computed(() =>
  rows.value
    .filter(row => !(row.type === 'product' && row.hasChildren))
    .map(row => row.id)
);

// 当前选中的 id 列表
const selectedIds = ref([]);

// 全选计算属性
const allSelected = computed({
  get: () => selectedIds.value.length === allIds.value.length,
  set: (value) => {
    if (value) {
      selectedIds.value = [...allIds.value]; // 全选
    } else {
      selectedIds.value = []; // 全不选
    }
  }
});

// 已选数量
const selectedCount = computed(() => selectedIds.value.length);

// 总价计算（选中项的价格 × 数量之和）
const totalPrice = computed(() => {
  let total = 0;
  rows.value.forEach(row => {
    if (selectedIds.value.includes(row.id)) {
      total += row.price * row.quantity;
    }
  });
  return total;
});

// 反选：将当前选中状态取反
// const inverseSelection = () => {
//   const all = allIds.value;
//   const currentlySelected = selectedIds.value;
//   const newSelected = all.filter(id => !currentlySelected.includes(id));
//   selectedIds.value = newSelected;
// };

// 检测屏幕尺寸
const checkScreenSize = () => {
  isMobile.value = window.innerWidth <= 768
}




// 方法
 

 

const DealProductsdata=(selectedTypes:any )=>
{

var getProducts=Productsdata(1,selectedTypes);
console.log(getProducts);


}
const GetProducts=(selectedTypes:any )=>{
selectedType.value=selectedTypes;
  DealProductsdata(selectedTypes);
}
const Productsdata = async (pageIndex: any, fullCategoryIds: any) => {
   // 商品数据
               
                 var listInfo = await Productlist({
                        pageIndex: pageIndex,
                        pageSize: 500,
                        shopTypeStatus: ShopTypeEmun.MayfousErp,
                        CategoryId: fullCategoryIds
                });
                
                 products.value = listInfo.data.list;
                 console.log("products.value",products.value)
                 }
// 生命周期
onMounted(() => {
  ListBusinessCategory(200000000000);
  console.log("selectedTypesss",selectedType.value);
  
 
  checkScreenSize()
  window.addEventListener('resize', checkScreenSize)
})


// 过滤出 isMainIntroduction 为 true 的项
const mainProducts = computed(() => {
  return products.value.find(item => item.isMainIntroduction === true);
});

// 将 SKU 数据扁平化，每个 SKU 生成一行，无 SKU 的产品生成一行占位
 

onUnmounted(() => {
  window.removeEventListener('resize', checkScreenSize)
})


// 将 SKU 数据扁平化，每个 SKU 生成一行，无 SKU 的产品生成一行占位
const flattenedSkus = computed(() => {
  const rows = [];
  var productIndex = 1; // 产品主序号（从1开始）
          
  products.value.forEach(product => {
  const skuList = product.productsGetSkuDto?.productsSkuInfoDto || [];
    if (skuList && skuList.length > 0) {
      // 有 SKU：每个 SKU 生成一行，序号为 主序号.子序号
       rows.push({
              id: `p-${product.id}`,                
          serial: `${productIndex}`,
         productId:product.id,
         skuid:"0",
        productName: product.productName,
        specValue: null,
        price: undefined,
        stockQty: undefined
      });
      skuList.forEach((sku, idx) => {
        rows.push({
           id: `s-${sku.skuId}`,
           serial: `${productIndex}.${idx + 1}`,
           productId:product.id,
           skuid:sku.skuId,
          productName: product.productName,
          specValue: sku.productsSpecsValueId.join(', '), // 多个规格值用逗号连接
          price: sku.price,
          stockQty: sku.stockQty
        });
      });
    } else {
      
      // 无 SKU 的产品，添加一行占位
      rows.push({
             id: `p-${product.id}`,       
         serial: `${productIndex}`,
          productId:product.id,
          skuid:"0",
        productName: product.productName,
        specValue: null,
        price: product.price,
        stockQty: product.stockQty,
      });
       
        console.log("productIndex",productIndex);
        
    }
     productIndex++; // 产品主序号递增
  });
  console.log("rows",rows);
  
  return rows;
});
// 使用计算属性合并所有商品的 imgs 数组
const productImagess = computed(() => {
  // 确保 products.value 是数组
  if (!Array.isArray(products.value)) return [];
  // 用 flatMap 将每个商品的 imgs 数组合并成一个
  return products.value.flatMap(item => item.imgs || []);
});

// 如果需要仅提取图片 URL 列表
const imageUrls = computed(() => productImagess.value.map(img => img.imageUrl));


const extractSelectedItems = (selectedRows) => {
 const productMap = new Map(); // key: productid

  selectedRows.forEach(row => {
    const productId = row.productid;
    const skuId = row.skuid;

    if (!productMap.has(productId)) {
      productMap.set(productId, { productId, skuIds: [] });
    }

    const entry = productMap.get(productId);

    // 如果是 SKU 行且 skuid 有效
    if (row.type === 'sku' && skuId && skuId !== '0') {
      if (!entry.skuIds.includes(skuId)) {
        entry.skuIds.push(skuId); // 去重
      }
    }
    // 商品行不需要额外处理，只保证条目存在即可
  });

  return Array.from(productMap.values());
};
// 结算功能
const handleCheckoutA = async () => {


  // const qrCodeString = "https://qr.alipay.com/bax036462l37zve42p5j00d9"
  // payDialogVisible.value = true;
  // const qrDom = document.getElementById('qrcodes')
  // if (qrDom) qrDom.innerHTML = ''
  // await nextTick();

  // // //   关键：清空容器，防止二维码叠加
  // // //   3. 获取DOM，增加判空兜底，防止null报错
  // new QRCode(document.getElementById("qrcodes"), {
  //   text: qrCodeString,
  //   width: 200,
  //   height: 200
  // });
                      
  };
const handleCheckout = async () => {
   if (selectedCount.value === 0) {
    ElMessage.warning('请先选择要结算的项');
    return;
  }
      const generateOrderNo = () => {
                    const timestamp = Date.now()
                    const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0')
                    return `ORD${timestamp}${random}`
                }
                
   const pendingOrder = ref({
                    orderNo: '',
                    items: [],
                    totalAmount: 0,
                    originalAmount: 0,
                    savedAmount: 0,
                    itemCount: 0,
                    createTime: ''
                })
    const selectedRows = rows.value.filter(row => selectedIds.value.includes(row.id));
  //  console.log("selectedRows", JSON.stringify(selectedRows, null, 2));
     // // 生成订单数据
                    const orderItems = selectedRows.map(item => ({
                       
                        productId: item.productid,
                        proUnitNum: item.proUnitNum,
                        proUnit: item.proUnit,
                        productSkuId: item.skuid,
                        productName: item.moduleName,
                        productSkuName:item.function,
                        productImgUrl:imageUrls.value[0],
                        price: item.price,
                       // originalPrice: item.originalPrice,
                        quantity: item.quantity,
                        subtotal: item.price * item.quantity
                    }))
                         const total = totalPrice.value;
                    console.log("orderItems",orderItems)
        pendingOrder.value = {
                        orderNo: generateOrderNo(),
                        items: orderItems,
                        totalAmount:total,
                        originalAmount: 0,
                        savedAmount:0 ,
                        itemCount: selectedCount.value,
                        createTime: new Date().toLocaleString()
                    }

                      console.log("pendingOrder",pendingOrder.value)
                         const requestData = {
                          IsNotOrdersDeliveryDetails:true,
                        ordersDeliveryDetailsDto: null,
                        listOrdersDetailsDto: pendingOrder.value.items.map(item => ({
                            quantity: item.quantity,
                            productId: item.productId,
                            productSkuId: item.productSkuId,
                              proUnitNum: item.proUnitNum,
                        proUnit: item.proUnit,
                        }))
                    }
                       console.log('提交数据:', requestData)
                         var CreateShopOrderData = await CreateShopOrder(requestData);
                           console.log("CreateShopOrderData", CreateShopOrderData);
                    if (CreateShopOrderData.data.status == true) {
                        ElMessage.success(CreateShopOrderData.data.msg);

                           var aass = {
                            "orderId": CreateShopOrderData.data.data.orderPayId,
                            "classID": 2221010
                        }

                         var code=await AlipayAbnormalForOrderPay(aass)
                         if (code.data.status == true) {
                           payDialogVisible.value = true;
                             // 清空旧二维码
                          await nextTick()
                           // 清空二维码容器，防止重复叠加
                            const qrDom = document.getElementById('qrcodes')
                            if (qrDom) qrDom.innerHTML = ''
                             // // 你提供的原生二维码生成代码，直接搬入Vue
                              new QRCode(document.getElementById("qrcodes"), {
                                  text: code.data.data,
                                  width: 200,
                                 height: 200
                              });
                             // 开启2秒一次轮询查询支付状态
                             pollTimer = window.setInterval(() => {
                                 queryOrderPayStatus(CreateShopOrderData.data.data.orderPayId)
                             }, 3000)
                              
                         }

                        
                    } else {
                        ElMessage.warning("添加失败" ,CreateShopOrderData.data.msg);
                    }
 
      console.log("total", total);
      // const checkoutData = extractSelectedItems(selectedRows);
      // console.log('结算数据：', checkoutData);
// ElMessageBox.confirm(
//     `确认结算选中的 ${selectedCount.value} 项，总价 ￥${total.toLocaleString()} 吗？`,
//     '结算确认',
//     {
//       confirmButtonText: '确定',
//       cancelButtonText: '取消',
//       type: 'info'
//     }
//   ).then(() => {
//     // 模拟提交订单
//     console.log('结算数据：', selectedRows);
//     ElMessage.success('结算成功！订单已提交');
//     // 可选：跳转到订单页面或清空选中
//     // selectedIds.value = [];
//   }).catch(() => {
//     ElMessage.info('取消结算');
//   });

  }

  const queryOrderPayStatus = async (orderId: string) => {
      var aass = {
                            "Id ":orderId,
                            "ClassID": 2221010
                        }
  const res = await GetOrdersOnlinePayment(aass)
  const status = res.data.payStatusId;
  // 1. 支付成功分支
  if (status === 2161020) {
    clearInterval(pollTimer!)
    pollTimer = null
    payDialogVisible.value = false
    // 跳转支付宝支付成功页面，携带订单参数
    router.push({
      path: '/Alipay/AlipaySuccess',
      query: {
        orderId: orderId,
        amount: totalPrice.value,
        tradeNo: res.data.tradeNo // 后端返回支付宝交易号
      }
    })
  }
  // 2. 订单超时/关闭（支付失败）
  //if (status === 'timeout' || status === 'closed')
   if (status === 2161030) {
    clearInterval(pollTimer!)
    pollTimer = null
    showQrcodeModal.value = false
    ElMessage.warning('订单已超时/取消，请重新提交订单')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["erp-app", { 'mobile-mode': isMobile.value }])
  }, [
    (isMobile.value)
      ? (_openBlock(), _createBlock(MobileHeader, {
          key: 0,
          "user-name": userName.value,
          onOpenSidebar: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = true))
        }, null, 8, ["user-name"]))
      : _createCommentVNode("", true),
    (isMobile.value)
      ? (_openBlock(), _createBlock(SidebarMobile, {
          key: 1,
          visible: sidebarOpen.value,
          modelValue: currentPage.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
          "user-name": userName.value,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (sidebarOpen.value = false))
        }, null, 8, ["visible", "modelValue", "user-name"]))
      : _createCommentVNode("", true),
    (!isMobile.value)
      ? (_openBlock(), _createBlock(SidebarPC, {
          key: 2,
          modelValue: currentPage.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentPage).value = $event)),
          "user-name": userName.value
        }, null, 8, ["modelValue", "user-name"]))
      : _createCommentVNode("", true),
    _createElementVNode("main", {
      class: _normalizeClass(["main-content", { 'with-sidebar': !isMobile.value }])
    }, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "breadcrumb" }, [
        _createElementVNode("span", null, "微科斯"),
        _createElementVNode("span", { class: "separator" }, "›"),
        _createElementVNode("span", { class: "current" }, "商品管理")
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "type-label" }, "系统类型", -1)),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(originalData.value, (type) => {
            return (_openBlock(), _createElementBlock("button", {
              key: type.categeroyId,
              class: _normalizeClass(["type-btn", { active: selectedType.value === type.categeroyId }]),
              onClick: ($event: any) => (GetProducts(type.categeroyId))
            }, _toDisplayString(type.categeroyName), 11, _hoisted_3))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "intro-header" }, [
          _createElementVNode("span", { class: "letter-badge" }, "A"),
          _createElementVNode("h3", null, "商品介绍：")
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          (imageUrls.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: imageUrls.value[currentImage.value]
                }, null, 8, _hoisted_7),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "image-badge" }, "主图", -1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageUrls.value, (thumb, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["thumbnail", { active: currentImage.value === index }]),
                onClick: ($event: any) => (currentImage.value = index)
              }, [
                _createElementVNode("img", {
                  src: thumb,
                  alt: `产品图${index + 1}`
                }, null, 8, _hoisted_10)
              ], 10, _hoisted_9))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (mainProducts.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: mainProducts.value.productDecription
              }, null, 8, _hoisted_12))
            : (_openBlock(), _createElementBlock("p", _hoisted_13, "暂无主介绍商品"))
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("label", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((allSelected).value = $event))
            }, null, 512), [
              [_vModelCheckbox, allSelected.value]
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("span", null, "全选", -1))
          ]),
          _createElementVNode("span", _hoisted_17, "已选 " + _toDisplayString(selectedCount.value) + " 项", 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("table", null, [
            _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { class: "checkbox-col" }),
                _createElementVNode("th", null, "序号"),
                _createElementVNode("th", null, "模块名称"),
                _createElementVNode("th", null, "功能"),
                _createElementVNode("th", null, "使用时间"),
                _createElementVNode("th", null, "数量"),
                _createElementVNode("th", null, "价格(元)")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: row.id,
                  class: _normalizeClass({ 'child-row': row.type === 'sku' })
                }, [
                  _createElementVNode("td", _hoisted_19, [
                    (!(row.type === 'product' && row.hasChildren))
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedIds).value = $event)),
                          value: row.id
                        }, null, 8, _hoisted_20)), [
                          [_vModelCheckbox, selectedIds.value]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(row.sn), 1),
                  _createElementVNode("td", null, _toDisplayString(row.moduleName), 1),
                  _createElementVNode("td", null, _toDisplayString(row.function), 1),
                  _createElementVNode("td", null, _toDisplayString(row.days), 1),
                  _createElementVNode("td", null, _toDisplayString(row.quantity), 1),
                  _createElementVNode("td", null, "￥" + _toDisplayString(row.price.toLocaleString()), 1)
                ], 2))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "total-label" }, "总价", -1)),
            _createElementVNode("span", _hoisted_23, "¥" + _toDisplayString(totalPrice.value.toLocaleString()), 1)
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "trial-notice" }, [
            _createElementVNode("span", { class: "notice-icon" }, "ⓘ"),
            _createElementVNode("span", { class: "notice-text" }, "*注意首次申请试用期为14天")
          ], -1)),
          _createElementVNode("div", { class: "action-buttons" }, [
            _cache[13] || (_cache[13] = _createElementVNode("button", { class: "btn btn-outline" }, "申请试用", -1)),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: handleCheckout
            }, "结算")
          ])
        ])
      ]),
      _createVNode(Foot)
    ], 2),
    _createVNode(_component_el_dialog, {
      modelValue: payDialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payDialogVisible).value = $event)),
      title: "支付宝支付",
      width: "420px",
      onClose: closePayDialog
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _cache[16] || (_cache[16] = _createElementVNode("div", {
              id: "qrcodes",
              class: "qrcode-container"
            }, null, -1)),
            _createElementVNode("p", _hoisted_26, "应付金额：¥" + _toDisplayString(totalPrice.value.toLocaleString()), 1)
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "pay-btns" }, [
            _createElementVNode("p", { class: "tip" }, "请使用支付宝APP扫码付款，5分钟内有效")
          ], -1))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})